import StoreDocuments from './StoreDocuments';

export default StoreDocuments;
